import React from "react"

import { Action } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { useAppSelector } from "../../../../hooks"
import { GlobalState } from "../../../../store"

import { IRCAFinding, IRootCauseAnalysisActions } from "../.."

export interface Props {
    finding: IRCAFinding
    actions: IRootCauseAnalysisActions
}

export const CategoryFinding = ({ finding, actions }: Props): JSX.Element => {
    const {
        labels,
        controls: { isReadOnly },
    } = useAppSelector((state: GlobalState) => state.incidents)

    return (
        <div
            className="tw-flex tw-px-2 has-hidden-actions tw-gap-2"
            data-ft-component="finding"
            data-ft-id={finding.id}
            data-ft-type={finding.nodeType}
        >
            <div
                className="tw-pl-4 tw-font-bold"
                data-ft-component="categoryTitle"
            >
                {finding.content}
            </div>

            {!isReadOnly && finding.canCreateNewFinding && (
                <Action
                    extraClasses="is-hidden-action"
                    title={labels.addNewFinding}
                    data-ft-component="createFinding"
                    onClick={(): void => {
                        actions.addNewFinding(finding.id)
                    }}
                >
                    {Symbols.Create}
                </Action>
            )}
        </div>
    )
}

export default CategoryFinding
